'use strict';

require('../css/index.less');

var _animate = require('./animate.js');

var _util = require('./util.js');

var _modal = require('./modal.js');

// 入场动画
// 通过webpack和babel打包
var animateMap = (0, _animate.initAnimate)();
var anchors = ['index', 'fuli', 'jingyinghui', 'ziliaopian', 'laowanjia'];

$('#fullpage').fullpage({
    easingcss3: '',
    anchors: anchors,
    navigation: true,
    scrollOverflow: true,
    // paddingTop: '36px',
    afterLoad: function afterLoad(anchor) {
        (animateMap[anchor] || []).forEach(function (item) {
            item.play();
        });
    },
    onLeave: function onLeave(index, nextIndex) {
        if (nextIndex !== 1) {
            $('#fp-nav').fadeIn(500);
        } else {
            $('#fp-nav').fadeOut(500);
        }
    }
});

$('#fp-nav').hide();

// 首页粒子动画
function initParticles() {
    var $particleBox = $('.js-particle');
    var bezierList = [[{ x: 0, y: 0 }, { x: 57, y: -80 }, { x: 584, y: 465 }, { x: 950, y: 374 }], [{ x: 0, y: 0 }, { x: 143, y: -97 }, { x: 386, y: 372 }, { x: 818, y: 468 }], [{ x: 0, y: 0 }, { x: 199, y: -98 }, { x: 663, y: 366 }, { x: 1092, y: 372 }], [{ x: 0, y: 0 }, { x: 305, y: -72 }, { x: 676, y: 155 }, { x: 1105, y: 352 }]];
    var $particles = $(new Array(50).join('<i></i>'));

    $particleBox.append($particles);

    $.each($particles, function (i, particle) {
        var size = (0, _util.random)(5, 20);
        var bezier = bezierList[(0, _util.random)(0, bezierList.length)];
        var scale = (0, _util.random)(5, 10) / 10;
        var $particle = $(particle);

        $particle.addClass('particle--' + (0, _util.random)(1, 6));

        var params = {
            scaleX: scale,
            scaleY: scale,
            ease: Power1.easeInOut,
            bezier: {
                type: 'thru',
                values: bezier,
                curviness: 1
            },
            repeat: -1,
            // delay: random(0, 20),
            opacity: .4
        };
        var tm = TweenMax.to($particle, (0, _util.random)(5, 15), params);
        tm.progress((0, _util.random)(0, 10) / 10);
    });
}

setTimeout(initParticles, 500);

// 弹窗
var modal = new _modal.Modal({
    el: $('.js-modal')[0],
    transition: 'slide'
});

$(modal.wrap).on('scroll', function (e) {
    return e.stopPropagation();
});

$('.js-modal-trigger a').click(function () {
    var index = $(this).index();
    $(modal.opts.el).find('.js-my-modal-content').hide().eq(index).show();
    modal.open();
});


//////////////////
// WEBPACK FOOTER
// ../src/js/index.js
// module id = 5
// module chunks = 0